import SwitchWorkspace from '../views/switch-workspace/SwitchWorkspace';
import { routeNames } from '../constants';

export default [
  {
    path: 'switch-workspace',
    name: routeNames.workspace.list,
    component: SwitchWorkspace,
    meta: {
      noTopNav: true,
    },
  },
];
